module.exports = __webpack_public_path__ + "img/mapipay2.18df3886.png";